import {Directive, HostListener} from "@angular/core";
import {intNumberPrevent, numberPrevent} from "src/infrastructure/helper/number-input-preventer";

@Directive({
    selector: 'input[preventIntNumber]',
    standalone: false
})
export class IntNumberDirective {
    @HostListener('keypress', ['$event']) onInput(event: KeyboardEvent) {
        intNumberPrevent(event);
    }
}


@Directive({
    selector: 'input[preventNumber]',
    standalone: false
})
export class NumberDirective {
    @HostListener('keypress', ['$event']) onInput(event: KeyboardEvent) {
        numberPrevent(event);
    }
}
